"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableSwapLayout = exports.FeesLayout = void 0;
const token_utils_1 = require("@saberhq/token-utils");
const BufferLayout = __importStar(require("buffer-layout"));
/**
 * Layout for StableSwap fees
 */
exports.FeesLayout = BufferLayout.struct([
    (0, token_utils_1.Uint64Layout)("adminTradeFeeNumerator"),
    (0, token_utils_1.Uint64Layout)("adminTradeFeeDenominator"),
    (0, token_utils_1.Uint64Layout)("adminWithdrawFeeNumerator"),
    (0, token_utils_1.Uint64Layout)("adminWithdrawFeeDenominator"),
    (0, token_utils_1.Uint64Layout)("tradeFeeNumerator"),
    (0, token_utils_1.Uint64Layout)("tradeFeeDenominator"),
    (0, token_utils_1.Uint64Layout)("withdrawFeeNumerator"),
    (0, token_utils_1.Uint64Layout)("withdrawFeeDenominator"),
], "fees");
/**
 * Layout for stable swap state
 */
exports.StableSwapLayout = BufferLayout.struct([
    BufferLayout.u8("isInitialized"),
    BufferLayout.u8("isPaused"),
    BufferLayout.u8("nonce"),
    (0, token_utils_1.Uint64Layout)("initialAmpFactor"),
    (0, token_utils_1.Uint64Layout)("targetAmpFactor"),
    BufferLayout.ns64("startRampTs"),
    BufferLayout.ns64("stopRampTs"),
    BufferLayout.ns64("futureAdminDeadline"),
    (0, token_utils_1.PublicKeyLayout)("futureAdminAccount"),
    (0, token_utils_1.PublicKeyLayout)("adminAccount"),
    (0, token_utils_1.PublicKeyLayout)("tokenAccountA"),
    (0, token_utils_1.PublicKeyLayout)("tokenAccountB"),
    (0, token_utils_1.PublicKeyLayout)("tokenPool"),
    (0, token_utils_1.PublicKeyLayout)("mintA"),
    (0, token_utils_1.PublicKeyLayout)("mintB"),
    (0, token_utils_1.PublicKeyLayout)("adminFeeAccountA"),
    (0, token_utils_1.PublicKeyLayout)("adminFeeAccountB"),
    exports.FeesLayout,
]);
//# sourceMappingURL=layout.js.map